<nav class="text-left">
  <button
    type="button"
    class="font-semibold mb-6 flex items-center text-left text-steel-20 transition-all text-small"
    [class.!mb-0]="limitTo()"
    (click)="toggleLimit()"
  >
    <span>
      {{ 'footer.location-links.' + verticalType + '.' + (isIndividual ? 'agents' : 'agencies') | lowercase | transloco }}
    </span>
    <span class="sr-only">{{ 'footer.location-links.view.' + (limitTo() ? 'more' : 'less') | transloco }}</span>
    <rma-icon class="ml-1 transform transition-all" [class.rotate-180]="!limitTo()" glyph="expand_more" size="small" />
  </button>

  <div
    class="flex max-h-full flex-col gap-6 transition-all"
    [ngClass]="{ '!max-h-0 overflow-hidden': limitTo(), 'grid grid-cols-2': isMultiColumn }"
  >
    @for (locationLink of locationLinks; track locationLink) {
      <a
        class="text-xs text-white no-underline hover:text-highlight-blue"
        [routerLink]="isIndividual ? locationLink[verticalType].agentUrl : locationLink[verticalType].agencyUrl"
      >
        {{ locationLink.name }}
      </a>
    }
  </div>
</nav>
